// target sales code............................

import React, { useEffect, useState, useRef } from "react";
import {
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  TableRow,
  Paper,
  Checkbox,
  Tooltip,
  Box,
  DialogContentText,
  TableFooter,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { EyeOutlined, Html5Filled } from "@ant-design/icons";
// import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons';
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { useSelector } from "react-redux";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { border, height, width } from "@mui/system";
import HttpService from "../services/httpService";
import { CSVLink } from "react-csv";
import { setLoading, setSnackInfo } from "../redux/actions/appAction";
import { connect } from "react-redux";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import axios from "axios";
import { ROLENAME } from '../utils';
const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    zIndex: 2,
  },
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    position: "relative",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    maxWidth: 400,
    margin: "0 auto",
  },
  button: {
    marginTop: theme.spacing(2),
  },
  table: {
    minWidth: 650,
    border: "1px solid #ddd", // Add border to the table
  },
  tableCell: {
    textAlign: "center",
    border: "1px solid #ddd", // Add border to table cells
    whiteSpace: "normal", // Allow wrapping of content
    wordWrap: "break-word", // Break words that exceed the width
    maxWidth: "150px", // Example maximum width
    padding: "8px", // Adjust padding as needed
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  input: {
    display: "none",
  },
  downloadButton: {
    backgroundColor: '#355025',   // Dark Blue
    color: '#FFF2EB',             // White text
    '&:hover': {
      backgroundColor: '#4A6641', // Derived lighter Dark Blue
    },
  },
}));
function SalesTarget(props) {

  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);

  const findDgm = userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales"));
  const findSalesHead = userDetails?.roles?.some((role) =>
    role?.name?.includes("Sales Head")
  );
  // const salesHeadAccess = ((findDgm&&findSalesHead)||findSalesHead)
  const salesHeadAccess = false;
  const [editOpen, setEditOpen] = useState(false);
  const [editClickTable, setEditClickTable] = useState();
  const [tableDatas, setTableDatas] = useState([]);
  const [yearFilterValue, setYearFilterValue] = useState(
    new Date().getFullYear()
  );
  const [openDialogEdit, setOpenDialogEdit] = useState(false);
  const [editAmountPayload, setEditAmountPayload] = useState([]);
  const [radioValue, setRadioValue] = useState("NA");
  const [adminTableData, setAdminTableData] = useState({});
  const [editInfoRow, setEditInfoRow] = useState({});
  const [hierarchyData, setHierarchyData] = useState({});
  const [adminCsvData, setAdminCsvData] = useState([]);
  const [hierarchyCsvData, setHierarchyCsvData] = useState([]);
  const [experienceCenterInfo, setExperienceCenterInfo] = useState("");
  const [editAmounts, setEditAmounts] = useState([]);
  const [getTemplateCsvData, setGetTemplateCsvData] = useState({});
  const [templateCsvMappingData, setTemplateCsvMappingData] = useState([]);
  const [allExeperienceCenter, setAllExperienceCenter] = useState({});
  const [selectExperienceCenter, setSelectExperienceCenter] = useState("all");
  const [headers, setHeaders] = useState([])
  const [adminToggle, setAdminToggle] = useState(false)

  const editAmountHandle = (index, userId, month, year) => (event) => {
    setEditAmounts((prevAmounts) => {
      // Ensure that prevAmounts is an array
      const updatedAmount = {
        indexNumber: index,
        userId: userId,
        year: year,
        month: month,
        amount: event.target.value,
      };

      // Check if an entry already exists for the given index, userId, month, and year
      const existingEntryIndex = Array.isArray(prevAmounts)
        ? prevAmounts.findIndex(
          (entry) =>
            entry.indexNumber === index &&
            entry.userId === userId &&
            entry.month === month &&
            entry.year === year
        )
        : -1;

      if (existingEntryIndex !== -1) {
        // Update the existing entry
        const updatedAmounts = [...prevAmounts];
        updatedAmounts[existingEntryIndex] = updatedAmount;
        return updatedAmounts;
      }

      // If no entry exists, push the new one
      return [...prevAmounts, updatedAmount];
    });
  };


  function editFunCloseHandle() {
    setEditOpen(false);
  }

  function targetEditCloseHandle() {
    setOpenDialogEdit(false);
    setEditAmountPayload([]);
  }

  function yearFilterHandle(e) {
    setYearFilterValue(e.target.value);
  }

  function targetEditOpenHandle() {
    setOpenDialogEdit(true);
  }

  // Calling api for get all user for  csv

  async function getTemplateCsvDataFunHandle() {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.getTemplateCsvDataApi();
      setGetTemplateCsvData(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }

  // template csv format-----------

  const templateCsvHeader = [
    { key: "userId", label: "User-Id" },
    { key: "name", label: "Name" },
    { key: "role", label: "Designation" },
    // { key: "year1", label: `${new Date().getFullYear()}`},
    { key: "year1", label: "year1" },
    { key: "4", label: "April" },
    { key: "5", label: "May" },
    { key: "6", label: "June" },
    { key: "7", label: "July" },
    { key: "8", label: "Aug" },
    { key: "9", label: "Sept" },
    { key: "10", label: "Oct" },
    { key: "11", label: "Nov" },
    { key: "12", label: "Dec" },
    // { key: "year1", label: `${new Date().getFullYear()+1}`},
    { key: "year2", label: "year2" },
    { key: "1", label: "Jan" },
    { key: "2", label: "Feb" },
    { key: "3", label: "March" },
  ];

  // mapping u data for template csv------

  function templateCsvHandle() {
    const csvFlattenData = getTemplateCsvData?.data?.map((item) => {
      return {
        userId: item?.userId || "N/A",
        name: item?.Name || "N/A",
        role: item?.Role?.join(", ") || "N/A",
        year1: `${new Date().getFullYear()}`,
        4: "",
        5: "",
        6: "",
        7: "",
        8: "",
        9: "",
        10: "",
        11: "",
        12: "",
        year2: `${new Date().getFullYear() + 1}`,
        1: "",
        2: "",
        3: "",
      };
    });
    setTemplateCsvMappingData(csvFlattenData);
  }

  // convert rs in comma saprator
  function formatRupees(amount) {
    const amountInLacs = amount / 100000;
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
    }).format(amountInLacs);
  }
  //  csv file header of admin
  const adminHeader = [
    { key: "name", label: "Name" },
    { key: "role", label: "Designation" },
    { key: "ec", label: "Experience-Center" },
    { key: "3", label: "March" },
    { key: "2", label: "Feb" },
    { key: "1", label: "Jan" },
    { key: "12", label: "Dec" },
    { key: "11", label: "Nov" },
    { key: "10", label: "Oct" },
    { key: "9", label: "Sept" },
    { key: "8", label: "Aug" },
    { key: "7", label: "July" },
    { key: "6", label: "June" },
    { key: "5", label: "May" },
    { key: "4", label: "April" },
    // { key: "total", label: "Total" },
  ];

  //Edit target function

  async function updateAmoutClickHandle() {
    async function getData() {
      const fullYear = new Date().getFullYear();
      try {
        props.setLoading(true); // Show loading indicator
        let res = await HttpService.editAmount({
          userId: editInfoRow?.user?.id,
          year: yearFilterValue || fullYear,
          monthlyTargets: editAmountPayload,
        });

        props.setSnackInfo(res.data.message); // Show success message
        setEditAmountPayload([]); // Reset payload
        props.setLoading(false); // Hide loading indicator
      } catch (error) {
        console.error("Error during API call:", error);
        props.setSnackInfo(error.message || "An error occurred"); // Show error message
        props.setLoading(false); // Hide loading indicator
      }
    }

    // Call getData function
    await getData();
    const isAdminOrCenterHead = userDetails?.roles?.some(role =>
      role?.name === ROLENAME.Admin|| role?.name === ROLENAME.CenterHead
    );

    if (isAdminOrCenterHead) {
      targetVisiabilityForAdminHanleFun(yearFilterValue, selectExperienceCenter);
    } else {
      hierarchyWiseGetDataHandle(userDetails._id, yearFilterValue);
    }

    // Additional logic
    // userGetDetails(); // Uncomment if required
  }
  function editAmountFunctionEdit(amount, monthName) {
    setEditAmountPayload((prevState) => {
      const updatedPayload = [...prevState]; // Clone the previous state array

      // Find the specific object based on the monthName
      const monthIndex = updatedPayload.findIndex(
        (item) => item.month === monthName
      );

      if (monthIndex !== -1) {
        updatedPayload[monthIndex] = {
          ...updatedPayload[monthIndex],
          target: +amount, // Update the amount for the specific month
        };
      } else {
        // Optionally: Add a new monthName entry if it doesn't exist
        updatedPayload.push({ target: +amount, month: monthName });
      }

      return updatedPayload;
    });
  }

  // finding month name via numbers
  function findMonthName(monthNumber) {
    const result =
      monthNumber === 1
        ? "Jan"
        : monthNumber === 2
        ? "Feb"
        : monthNumber === 3
        ? "March"
        : monthNumber === 4
        ? "Apr"
        : monthNumber === 5
        ? "May"
        : monthNumber === 6
        ? "June"
        : monthNumber === 7
        ? "July"
        : monthNumber === 8
        ? "Aug"
        : monthNumber === 9
        ? "Sept"
        : monthNumber === 10
        ? "Oct"
        : monthNumber === 11
        ? "Nov"
        : monthNumber === 12
        ? "Dec"
        : "Invalid month";
    // - {ele.year}

    return result;
  }
  //upload csv function
  async function checkUploadFile(event) {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      props.setLoading(true);
      try {
        const response = await HttpService.uploadFile(formData);
        const s3Link = response.data.s3Link || response.data;
        if (s3Link) {
          const responseOfUploadFile = await HttpService.uploadCsvAdmin(s3Link);
          props.setSnackInfo(`${responseOfUploadFile?.data?.msg}`);
          targetVisiabilityForAdminHanleFun(
            yearFilterValue,
            selectExperienceCenter
          );
        } else {
          console.warn("S3 link not found in response data");
        }

        props.setLoading(false);
      } catch (error) {
        console.error("Error uploading file:", error);
        props.setSnackInfo(error?.response?.data?.message, "error");
        props.setLoading(false);
      }
    } else {
      console.warn("No file selected");
    }
  }

  // Get All Experience Center

  async function getExperienceCenterHandleFun() {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.getAllExperienceCenter();
      setAllExperienceCenter(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }

  // Admin Table Data

  async function targetVisiabilityForAdminHanleFun(year, ecId) {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.targetVisiabilityForAdmin(year, ecId);
      setAdminTableData(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }

  // hierarchy Data
  async function hierarchyWiseGetDataHandle(userId, year) {
    try {
      props.setLoading(true);
      const fetchData = await HttpService.targetHierarchyWise(userId, year);
      setHierarchyData(fetchData.data);
      props.setLoading(false);
    } catch (error) {
      props.setLoading(false);
    }
  }

  const dgmId = hierarchyData?.data?.dgm?.map((exe) => exe?.user?.id).join(", ");
  const agmId = hierarchyData?.data?.agm?.map((exe) => exe?.user?.id).join(", ");
  const smId = hierarchyData?.data?.manager?.map((exe) => exe?.user?.id).join(", ");
  const asmId = hierarchyData?.data?.assistantManager?.map((exe) => exe?.user?.id).join(", ");
  const executiveId = hierarchyData?.data?.executive?.map((exe) => exe?.user?.id).join(", ");

  // Finding longest array for admin visibility----------
  const longestTargetsArrayAdminDgm = adminTableData?.data?.dgm?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);

  const longestTargetsArrayAdminAgm = adminTableData?.data?.agm?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);

  const longestTargetsArrayAdminSm = adminTableData?.data?.salesManager?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);

  const longestTargetsArrayAdminAsm = adminTableData?.data?.assistantManager?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);

  const longestTargetsArrayAdminSe = adminTableData?.data?.salesUser?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);


  // Finding longest array for Hierarchy visibility----------
  const longestTargetsArrayHierarchyDgm = hierarchyData?.data?.dgm?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);

  const longestTargetsArrayHierarchyAgm = hierarchyData?.data?.agm?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);

  const longestTargetsArrayHierarchySm = hierarchyData?.data?.manager?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);

  const longestTargetsArrayHierarchyAsm = hierarchyData?.data?.assistantManager?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);

  const longestTargetsArrayHierarchySe = hierarchyData?.data?.executive?.reduce((longest, current) => {
    const currentTargets = current?.targets || []; // Default to empty array if undefined
    return currentTargets.length > longest.length ? currentTargets : longest;
  }, []);




  // CSV useEffect
  useEffect(() => {
    if (
      userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) ||
      salesHeadAccess
    ) {
      if (!adminTableData?.data?.dgm) return; // Ensure data exists before proceeding
    } else {
      if (
        !hierarchyData?.data?.dgm &&
        !hierarchyData?.data?.agm &&
        !hierarchyData?.data?.manager &&
        !hierarchyData?.data?.assistantManager &&
        !hierarchyData?.data?.executive
      ) {
        return;
      }
    }

    // admin csv flattenedData....
    const flattenedDataDgm = adminTableData?.data?.dgm.map((item) => {
      const targets = item?.targets || []; // Default to an empty array if targets are missing

      return {
        name: item?.user?.name || "N/A",
        role: item?.user?.role || "N/A",
        ec: item?.user?.experienceCenter?.join(", ") || "N/A",
        4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
        5: targets[1]?.value || 0,
        6: targets[2]?.value || 0,
        7: targets[3]?.value || 0,
        8: targets[4]?.value || 0,
        9: targets[5]?.value || 0,
        10: targets[6]?.value || 0,
        11: targets[7]?.value || 0,
        12: targets[8]?.value || 0,
        1: targets[9]?.value || 0,
        2: targets[10]?.value || 0,
        3: targets[11]?.value || 0,
      };
    });

    const flattenedDataAgm = adminTableData?.data?.agm.map((item) => {
      const targets = item?.targets || []; // Default to an empty array if targets are missing

      return {
        name: item?.user?.name || "N/A",
        role: item?.user?.role || "N/A",
        ec: item?.user?.experienceCenter?.join(", ") || "N/A",
        4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
        5: targets[1]?.value || 0,
        6: targets[2]?.value || 0,
        7: targets[3]?.value || 0,
        8: targets[4]?.value || 0,
        9: targets[5]?.value || 0,
        10: targets[6]?.value || 0,
        11: targets[7]?.value || 0,
        12: targets[8]?.value || 0,
        1: targets[9]?.value || 0,
        2: targets[10]?.value || 0,
        3: targets[11]?.value || 0,
      };
    });

    const flattenedDataSalesManager = adminTableData?.data?.salesManager.map(
      (item) => {
        const targets = item?.targets || []; // Default to an empty array if targets are missing

        return {
          name: item?.user?.name || "N/A",
          role: item?.user?.role || "N/A",
          ec: item?.user?.experienceCenter?.join(", ") || "N/A",
          4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
          5: targets[1]?.value || 0,
          6: targets[2]?.value || 0,
          7: targets[3]?.value || 0,
          8: targets[4]?.value || 0,
          9: targets[5]?.value || 0,
          10: targets[6]?.value || 0,
          11: targets[7]?.value || 0,
          12: targets[8]?.value || 0,
          1: targets[9]?.value || 0,
          2: targets[10]?.value || 0,
          3: targets[11]?.value || 0,
        };
      }
    );

    const flattenedDataAssistantManager =
      adminTableData?.data?.assistantManager.map((item) => {
        const targets = item?.targets || []; // Default to an empty array if targets are missing

        return {
          name: item?.user?.name || "N/A",
          role: item?.user?.role || "N/A",
          ec: item?.user?.experienceCenter?.join(", ") || "N/A",
          4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
          5: targets[1]?.value || 0,
          6: targets[2]?.value || 0,
          7: targets[3]?.value || 0,
          8: targets[4]?.value || 0,
          9: targets[5]?.value || 0,
          10: targets[6]?.value || 0,
          11: targets[7]?.value || 0,
          12: targets[8]?.value || 0,
          1: targets[9]?.value || 0,
          2: targets[10]?.value || 0,
          3: targets[11]?.value || 0,
        };
      });

    const flattenedDataSalesUser = adminTableData?.data?.salesUser.map(
      (item) => {
        const targets = item?.targets || []; // Default to an empty array if targets are missing

        return {
          name: item?.user?.name || "N/A",
          role: item?.user?.role || "N/A",
          ec: item?.user?.experienceCenter?.join(", ") || "N/A",
          4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
          5: targets[1]?.value || 0,
          6: targets[2]?.value || 0,
          7: targets[3]?.value || 0,
          8: targets[4]?.value || 0,
          9: targets[5]?.value || 0,
          10: targets[6]?.value || 0,
          11: targets[7]?.value || 0,
          12: targets[8]?.value || 0,
          1: targets[9]?.value || 0,
          2: targets[10]?.value || 0,
          3: targets[11]?.value || 0,
        };
      }
    );

    const emptyRow = {
      name: "",
      role: "",
      ec: "",
      3: "", // Ensure value exists, otherwise default to 0
      2: "",
      1: "",
      12: "",
      11: "",
      10: "",
      9: "",
      8: "",
      7: "",
      6: "",
      5: "",
      4: "",
    };

    if (userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "all") {
      setAdminCsvData([
        ...flattenedDataDgm,
        emptyRow,
        ...flattenedDataAgm,
        emptyRow,
        ...flattenedDataSalesManager,
        emptyRow,
        ...flattenedDataAssistantManager,
        emptyRow,
        ...flattenedDataSalesUser,
      ]);
    } else if (userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "DGM"
    ) {
      setAdminCsvData(flattenedDataDgm);
    } else if (userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "AGM"
    ) {
      setAdminCsvData(flattenedDataAgm);
    } else if (userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "SM"
    ) {
      setAdminCsvData(flattenedDataSalesManager);
    } else if (userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "ASM"
    ) {
      setAdminCsvData(flattenedDataAssistantManager);
    } else if (userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "SE"
    ) {
      setAdminCsvData(flattenedDataSalesUser);
    }

    // Hierarchy csv flattenedData........

    const hierarchyFlattenedDataDgm = hierarchyData?.data?.dgm.map((item) => {
      const targets = item?.targets || []; // Default to an empty array if targets are missing

      return {
        name: item?.user?.name || "N/A",
        role: item?.user?.role || "N/A",
        ec: item?.user?.experienceCenter?.join(", ") || "N/A",
        4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
        5: targets[1]?.value || 0,
        6: targets[2]?.value || 0,
        7: targets[3]?.value || 0,
        8: targets[4]?.value || 0,
        9: targets[5]?.value || 0,
        10: targets[6]?.value || 0,
        11: targets[7]?.value || 0,
        12: targets[8]?.value || 0,
        1: targets[9]?.value || 0,
        2: targets[10]?.value || 0,
        3: targets[11]?.value || 0,
      };
    });

    const hierarchyFlattenedDataAgm = hierarchyData?.data?.agm.map((item) => {
      const targets = item?.targets || []; // Default to an empty array if targets are missing

      return {
        name: item?.user?.name || "N/A",
        role: item?.user?.role || "N/A",
        ec: item?.user?.experienceCenter?.join(", ") || "N/A",
        4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
        5: targets[1]?.value || 0,
        6: targets[2]?.value || 0,
        7: targets[3]?.value || 0,
        8: targets[4]?.value || 0,
        9: targets[5]?.value || 0,
        10: targets[6]?.value || 0,
        11: targets[7]?.value || 0,
        12: targets[8]?.value || 0,
        1: targets[9]?.value || 0,
        2: targets[10]?.value || 0,
        3: targets[11]?.value || 0,
      };
    });

    const hierarchyFlattenedDataSalesManager = hierarchyData?.data?.manager.map(
      (item) => {
        const targets = item?.targets || []; // Default to an empty array if targets are missing

        return {
          name: item?.user?.name || "N/A",
          role: item?.user?.role || "N/A",
          ec: item?.user?.experienceCenter?.join(", ") || "N/A",
          4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
          5: targets[1]?.value || 0,
          6: targets[2]?.value || 0,
          7: targets[3]?.value || 0,
          8: targets[4]?.value || 0,
          9: targets[5]?.value || 0,
          10: targets[6]?.value || 0,
          11: targets[7]?.value || 0,
          12: targets[8]?.value || 0,
          1: targets[9]?.value || 0,
          2: targets[10]?.value || 0,
          3: targets[11]?.value || 0,
        };
      }
    );

    const hierarchyFlattenedDataAssistantManager =
      hierarchyData?.data?.assistantManager.map((item) => {
        const targets = item?.targets || []; // Default to an empty array if targets are missing

        return {
          name: item?.user?.name || "N/A",
          role: item?.user?.role || "N/A",
          ec: item?.user?.experienceCenter?.join(", ") || "N/A",
          4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
          5: targets[1]?.value || 0,
          6: targets[2]?.value || 0,
          7: targets[3]?.value || 0,
          8: targets[4]?.value || 0,
          9: targets[5]?.value || 0,
          10: targets[6]?.value || 0,
          11: targets[7]?.value || 0,
          12: targets[8]?.value || 0,
          1: targets[9]?.value || 0,
          2: targets[10]?.value || 0,
          3: targets[11]?.value || 0,
        };
      });

    const hierarchyFlattenedDataSalesUser = hierarchyData?.data?.executive.map(
      (item) => {
        const targets = item?.targets || []; // Default to an empty array if targets are missing

        return {
          name: item?.user?.name || "N/A",
          role: item?.user?.role || "N/A",
          ec: item?.user?.experienceCenter?.join(", ") || "N/A",
          4: targets[0]?.value || 0, // Ensure value exists, otherwise default to 0
          5: targets[1]?.value || 0,
          6: targets[2]?.value || 0,
          7: targets[3]?.value || 0,
          8: targets[4]?.value || 0,
          9: targets[5]?.value || 0,
          10: targets[6]?.value || 0,
          11: targets[7]?.value || 0,
          12: targets[8]?.value || 0,
          1: targets[9]?.value || 0,
          2: targets[10]?.value || 0,
          3: targets[11]?.value || 0,
        };
      }
    );

    if (!userDetails.roles.find(role => role?.name === ROLENAME.CenterHead || role?.name === ROLENAME.Admin || role?.name === ROLENAME.FinanceManager || role?.name === ROLENAME.FinanceExecutive || role?.name === ROLENAME.FinanceUser) &&
      radioValue === "NA"
    ) {
      setHierarchyCsvData([
        ...hierarchyFlattenedDataDgm,
        emptyRow,
        ...hierarchyFlattenedDataAgm,
        emptyRow,
        ...hierarchyFlattenedDataSalesManager,
        emptyRow,
        ...hierarchyFlattenedDataAssistantManager,
        emptyRow,
        ...hierarchyFlattenedDataSalesUser,
      ]);
    } else if (!userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "DGM"
    ) {
      setHierarchyCsvData(hierarchyFlattenedDataDgm);
    } else if (!userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "AGM"
    ) {
      setHierarchyCsvData(hierarchyFlattenedDataAgm);
    } else if (!userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "SM"
    ) {
      setHierarchyCsvData(hierarchyFlattenedDataSalesManager);
    } else if (!userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "ASM"
    ) {
      setHierarchyCsvData(hierarchyFlattenedDataAssistantManager);
    } else if (!userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) &&
      radioValue === "SE"
    ) {
      setHierarchyCsvData(hierarchyFlattenedDataSalesUser);
    }

    // template csv call
    templateCsvHandle();
    // setAdminCsvData(flattenedDataDgm);
  }, [
    adminTableData,
    radioValue,
    hierarchyData,
    getTemplateCsvData,
    selectExperienceCenter,
  ]);

  useEffect(() => {
    // targetVisiabilityForAdminHanleFun(yearFilterValue)
    if (
      userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) ||
      salesHeadAccess
    ) {
      targetVisiabilityForAdminHanleFun(
        yearFilterValue,
        selectExperienceCenter
      );
      getTemplateCsvDataFunHandle();
      getExperienceCenterHandleFun();
    } else {
      hierarchyWiseGetDataHandle(userDetails?._id, yearFilterValue);
    }
  }, [yearFilterValue, selectExperienceCenter, userDetails]);

  useEffect(() => {
    if (!adminTableData?.data?.salesUser[0]?.targets) {
      return;
    }

    const tempArr = adminTableData?.data?.salesUser[0]?.targets.map((ele) =>
      ele
        ? { year: ele?.year, month: ele?.month }
        : "Unknown Year"
    );

    const headers = [
      { key: "name", label: "Name" },
      { key: "role", label: "Designation" },
      { key: "ec", label: "Experience-Center" },
      ...tempArr.map((ele) => ({
        key: ele?.month?.toString(),
        label: `${findMonthName(ele?.month)}-${ele?.year}`,
      })),
    ];
    setHeaders(headers)
  }, [adminTableData])

  useEffect(() => {
    if (!hierarchyData?.data?.executive[0]?.targets) {
      return;
    }

    const tempArr = hierarchyData?.data?.executive[0]?.targets.map((ele) =>
      ele
        ? { year: ele?.year, month: ele?.month }
        : "Unknown Year"
    );

    const headers = [
      { key: "name", label: "Name" },
      { key: "role", label: "Designation" },
      { key: "ec", label: "Experience-Center" },
      ...tempArr.map((ele) => ({
        key: ele?.month?.toString(),
        label: `${findMonthName(ele?.month)}-${ele?.year}`,
      })),
    ];
    setHeaders(headers)

  }, [hierarchyData])

  useEffect(()=>{
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.DGM_Sales)){
      setRadioValue("DGM")
    }
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.AGMSales)){
      setRadioValue("AGM")
    }
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.AssistantSalesManager)){
      setRadioValue("ASM")
    }
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.SalesManager)){
      setRadioValue("SM")
    }
    if(userDetails?.roles?.some((role) => role?.name === ROLENAME.SalesUser)){
      setRadioValue("SE")
    }
  },[userDetails])

  const currentYear = new Date().getFullYear();
  const financialYears = [
      { value: currentYear - 2, label: `${currentYear - 2}-${currentYear - 1}` },
      { value: currentYear - 1, label: `${currentYear - 1}-${currentYear}` },
      { value: currentYear, label: `${currentYear}-${currentYear + 1}` },
  ];
  
  return (
    <div>
      {/* view dialog of admin */}
      <Dialog
        open={editOpen}
        onClose={editFunCloseHandle}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "100%", // Set custom width
            maxHeight: "80vh", // Optionally limit height
          },
        }}
      >
        <DialogContent

        // style={{border:"2px solid black", width:"800px"}}
        >
          <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
            <Table
              className={classes.table}
              aria-label="knowledge details table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    Sl.No
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    Month/Year
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    City
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    Experience Center
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    User Name
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    Target Amount
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableDatas?.budgetArray &&
                  tableDatas?.budgetArray[editClickTable]?.targets?.map(
                    (ele, index) => {
                      return (
                        <TableRow
                        // key={index}
                        >
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {" "}
                            {ele.month === 1
                              ? "January"
                              : ele.month === 2
                              ? "February"
                              : ele.month === 3
                              ? "March"
                              : ele.month === 4
                              ? "April"
                              : ele.month === 5
                              ? "May"
                              : ele.month === 6
                              ? "June"
                              : ele.month === 7
                              ? "July"
                              : ele.month === 8
                              ? "August"
                              : ele.month === 9
                              ? "Septempber"
                              : ele.month === 10
                              ? "October"
                              : ele.month === 11
                              ? "November"
                              : ele.month === 12
                              ? "December"
                              : "Na"}{" "}
                            - {ele.year}
                          </TableCell>

                          <TableCell className={classes.tableCell}>
                            {ele.experienceCenters[0].location}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.experienceCenters[0].name}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele.userName}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            <TextField
                              id="date"
                              type="number"
                              value={
                                // Find the matching entry in editAmounts by index, userId, month, and year
                                editAmounts.find(
                                  (entry) =>
                                    entry.indexNumber === index &&
                                    entry.userId === ele.userId &&
                                    entry.month === ele.month &&
                                    entry.year === ele.year
                                )?.amount !== undefined
                                  ? editAmounts.find(
                                      (entry) =>
                                        entry.indexNumber === index &&
                                        entry.userId === ele.userId &&
                                        entry.month === ele.month &&
                                        entry.year === ele.year
                                    ).amount
                                  : ele.targetAmount
                              }
                              onChange={editAmountHandle(
                                index,
                                ele.userId,
                                ele.month,
                                ele.year
                              )} // pass the row's ID
                              InputLabelProps={{
                                shrink: true,
                              }}
                              fullWidth
                              className={classes.textField}
                            />
                          </TableCell>

                          <TableCell style={{ textAlign: "center" }}>
                            <DeleteIcon
                              style={{
                                fontSize: "28px",
                                color: "red",
                                padding: "5px",
                                cursor: "pointer",
                              }}
                              // onClick={() => {
                              //   setDeleteWholeTeam(ele);
                              // }}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            style={{
              backgroundColor: editAmounts.length > 0 ? "#355025" : "gray",
            }}
            variant="contained"
            color="primary"
          >
            Update
          </Button>
          <Button
            onClick={editFunCloseHandle}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* ........................Edit dialog for Admin............ */}
      <Dialog
        open={openDialogEdit}
        onClose={targetEditCloseHandle}
        maxWidth="lg" // Adjust maxWidth ('xs', 'sm', 'md', 'lg', 'xl' for default sizes)
        PaperProps={{
          style: {
            width: "100%", // Set custom width
            maxHeight: "80vh", // Optionally limit height
          },
        }}
      >
        <DialogContent

        // style={{border:"2px solid black", width:"800px"}}
        >
          <Typography style={{ textAlign: "center" }}>
            Edit Target Amount for {editInfoRow?.user?.name}, year-
            {yearFilterValue || new Date().getFullYear()},
            {experienceCenterInfo.teamName}
          </Typography>
          <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
            <Table
              className={classes.table}
              aria-label="knowledge details table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    Sl.No
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    Month
                  </TableCell>
                  <TableCell
                    className={classes.tableCell}
                    style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                  >
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {editInfoRow?.targets?.map((items, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className={classes.tableCell}>
                        {index + 1}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {findMonthName(items.month)}-
                        {items.month == 3 ||
                          items.month == 2 ||
                          items.month == 1
                          ? yearFilterValue + 1
                          : yearFilterValue}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        <TextField
                          id="amount"
                          type="text"
                          value={
                            editAmountPayload.length > 0
                              ? editAmountPayload.find(
                                (item) => item.month === items.month
                              )?.target
                              : items.value
                          }
                          // value={item.value}
                          onChange={(e) => {
                            editAmountFunctionEdit(e.target.value, items.month); // Pass the amount and monthName
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          fullWidth
                          className={classes.textField}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            style={{
              backgroundColor: editAmountPayload.length > 0 ? "#355025" : "gray",
            }}
            variant="contained"
            color="primary"
            onClick={() => {
              updateAmoutClickHandle();
              targetEditCloseHandle();
            }}
          >
            Update
          </Button>
          <Button
            onClick={targetEditCloseHandle}
            variant="contained"
            color="secondary"
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/*----------------------- Requirement change code------------------- */}

      {/* -----------Dgm table--- */}

      <Box>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex" }}>
            <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
              <InputLabel id="demo-select-small-label">Choose FY</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={yearFilterValue}
                label="Select Experience"
                onChange={yearFilterHandle}
              >
                {financialYears.map((year) => (
                  <MenuItem key={year.value} value={year.value}>
                    {year.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* ------------experience Center option------- */}
            {(userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead) ||
              salesHeadAccess) &&
              (<FormControl sx={{ m: 1, minWidth: 100 }} size="small">
                <InputLabel id="experience-center-label">
                  Choose EC
                </InputLabel>
                <Select
                  labelId="experience-center-label"
                  id="experience-center-select"
                  value={selectExperienceCenter}
                  label="Experience Center"
                  onChange={(e) => setSelectExperienceCenter(e.target.value)}
                >
                  {/* Default Option */}
                  <MenuItem value="all">All</MenuItem>

                  {/* Render Options Dynamically */}
                  {(userDetails?.roles?.some((role) => role?.name === ROLENAME.Admin || role?.name === ROLENAME.CenterHead)) &&
                    allExeperienceCenter?.data?.length > 0 &&
                    allExeperienceCenter.data.map((ele) => (
                      <MenuItem key={ele?._id} value={ele?._id}>
                        {ele.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              )}
            {/*  new.... */}
            {
              !userDetails?.roles?.some((role) =>
                role.name.includes("Sales User")
              ) && (
                <Box>
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      // justifyContent: "center",
                      // alignItems: "center",
                      // justifyContent: "space-between",
                      marginTop: "5px",
                    }}
                  >
                    <FormLabel
                      id="demo-radio-buttons-group-label"
                      sx={{ marginLeft: "10px", marginRight: "10px", marginTop:"10px" }}
                    >
                      Select Role
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={radioValue}
                      name="radio-buttons-group"
                      sx={{ display: "flex", flexDirection: "row" }} // Add flexDirection: "row"
                      onChange={(e) => {
                        setRadioValue(e.target.value);
                        setAdminToggle(true)
                      }}
                    >
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("Center Head") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("AGM Sales")
                    ) && (
                      <FormControlLabel
                        value="all"
                        control={<Radio />}
                        label="All"
                      />
                      )}  
                    {userDetails?.roles?.some(
                      (role) =>
                        role?.name?.includes("Admin") ||
                        role?.name?.includes("DGM Sales") ||
                        role?.name?.includes("Sales Head") ||
                        role?.name?.includes("Center Head")
                    ) && (
                        <FormControlLabel
                          value="DGM"
                          control={<Radio />}
                          label="DGM"
                        />
                      )}

                      {userDetails?.roles?.some(
                        (role) =>
                          role?.name?.includes("Admin") ||
                          role?.name?.includes("DGM Sales") ||
                          role?.name?.includes("Sales Head") ||
                          role?.name?.includes("AGM Sales") ||
                          role?.name?.includes("Center Head")
                      ) && (
                          <FormControlLabel
                            value="AGM"
                            control={<Radio />}
                            label="AGM"
                          />
                        )}
                      {userDetails?.roles?.some(
                        (role) =>
                          role?.name?.includes("Admin") ||
                          role?.name?.includes("DGM Sales") ||
                          role?.name?.includes("Sales Head") ||
                          role?.name?.includes("AGM Sales") ||
                          !role?.name?.includes("Assistant Sales Manager") ||
                          role?.name?.includes("Center Head")
                      ) && (
                          <FormControlLabel
                            value="SM"
                            control={<Radio />}
                            label="SM"
                          />
                        )}
                      {userDetails?.roles?.some(
                        (role) =>
                          role?.name?.includes("Admin") ||
                          role?.name?.includes("DGM Sales") ||
                          role?.name?.includes("Sales Head") ||
                          role?.name?.includes("AGM Sales") ||
                          role?.name?.includes("Assistant Sales Manager") ||
                          role?.name?.includes("Sales Manager") ||
                          role?.name?.includes("Center Head")
                      ) && (
                          <FormControlLabel
                            value="ASM"
                            control={<Radio />}
                            label="ASM"
                          />
                        )}
                      <FormControlLabel value="SE" control={<Radio />} label="SE" />
                    </RadioGroup>
                  </FormControl>
                </Box>
              )}
          </Box>

        <Box>
        {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
            JSON.stringify(getTemplateCsvData) !== "{}" && templateCsvHeader.length>0 && (
              <Button
                variant="contained"
                color="primary"
                style={{
                  height: "40px",
                  marginTop: "9px",
                  marginLeft: "8px",
                  fontSize: "12px",
                }}
                className={classes.downloadButton}
              >
                <CSVLink
                  data={templateCsvMappingData || []}
                  headers={templateCsvHeader || []}
                  filename={"Template CSV"}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    // fontSize: "12px",
                  }}
                >
                  Download Template CSV
                </CSVLink>
              </Button>
            )}

          <input
            accept=".csv, .xlsx"
            className={classes.input}
            id="imos-hardware-button-file"
            onChange={checkUploadFile}
            type="file"
          // disabled={projectStatus === "Completed"}
          />
          {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
            <label htmlFor="imos-hardware-button-file">
              <Button
                variant="contained"
                color="primary"
                component="span"
                style={{
                  fontSize: "12px",
                  height: "40px",
                  marginTop: "9px",
                  marginLeft: "6px",
                }}
                className={classes.downloadButton}
              >
                Upload Target CSV
              </Button>
            </label>
          )}

          {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
            (JSON.stringify(adminTableData) !== "{}" && adminCsvData.length > 0 && adminToggle && headers.length>0) &&(
              <Button
                variant="contained"
                color="primary"
                style={{
                  height: "40px",
                  marginTop: "9px",
                  marginLeft: "6px",
                  fontSize: "12px",
                }}
                className={classes.downloadButton}
              >
                <CSVLink
                  data={adminCsvData || []}
                  headers={headers || []}
                  filename={`target of ${yearFilterValue}-${yearFilterValue + 1
                    }`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    // fontSize: "12px",
                  }}
                >
                  Download Target CSV
                </CSVLink>
              </Button>
            )}
          {!(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
            JSON.stringify(hierarchyCsvData) !== "{}" && headers.length > 0 && (
              <Button
                variant="contained"
                color="primary"
                style={{
                  height: "40px",
                  marginTop: "9px",
                  marginLeft: "6px",
                  fontSize: "12px",
                }}
                className={classes.downloadButton}
              >
                <CSVLink
                  data={hierarchyCsvData || []}
                  headers={headers || []}
                  filename={`target of ${yearFilterValue}-${yearFilterValue + 1
                    }`}
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    // fontSize: "12px",
                  }}
                >
                  Download Target CSV
                </CSVLink>
              </Button>
            )}
        </Box>

        </Box>
      </Box>
      <Box style={{ textAlign: "right" }}>
        {" "}
        <b> All the amounts are showing in lacs ( ₹ )</b>
      </Box>

      {userDetails?.roles?.some(
        (role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head")
      ) &&
        JSON.stringify(adminTableData) !== "{}" &&
        radioValue !== "NA" && 
        !adminTableData?.data?.dgm?.length &&
        !adminTableData?.data?.agm?.length &&
        !adminTableData?.data?.salesManager?.length &&
        !adminTableData?.data?.assistantManager?.length &&
        !adminTableData?.data?.salesUser?.length && (
          <div style={{ textAlign: "center" }}>
            No Data found for {yearFilterValue}
          </div>
        )}


      {!(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
        (JSON.stringify(hierarchyData) !== "{}" &&
          hierarchyData?.data?.executive?.length === 0 &&
          hierarchyData?.data?.assistantManager?.length === 0 &&
          hierarchyData?.data?.manager?.length === 0 &&
          hierarchyData?.data?.agm?.length === 0 &&
          hierarchyData?.data?.dgm?.length === 0) && (
          <div style={{ textAlign: "center" }}>
            No Data found for {yearFilterValue}
          </div>
        )}

      {/* -----------------------DGM Table For admin-------------------------------- */}


      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head"))) &&
        JSON.stringify(adminTableData) !== "{}" &&
        adminTableData?.data?.dgm.length > 0 &&
        (radioValue === "all" || radioValue === "DGM") && (
          <div>
            <h3>DGM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>

                    {longestTargetsArrayAdminDgm?.map((header, headerIndex) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          key={`header-${headerIndex}`}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                          {/* March-
                      {`${yearFilterValue + 1 || new Date().getFullYear() + 1}`} */}
                        </TableCell>
                      );
                    })}
                    {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
                      (
                        <TableCell
                          className={classes.tableCell}
                          style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminTableData) !== "{}" &&
                    adminTableData?.data?.dgm.map((ele, index) => (
                      <TableRow key={`row-${index}`}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {ele?.user?.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={ele?.user?.experienceCenter?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {ele?.user?.experienceCenter
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {ele?.user?.experienceCenter?.length > 3 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>

                        {ele?.targets?.map((item, itemIndex) => {
                          return (
                            <TableCell className={classes.tableCell} key={`target-${index}-${itemIndex}`}>
                              {/* {formatRupees(item.value)} */}
                              {formatRupees(item.value)}
                            </TableCell>
                          );
                        })}

                        {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                          <TableCell className={classes.tableCell}>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "37px",
                                  color: "gray",
                                  padding: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setEditInfoRow(ele);
                                  // setExperienceCenterInfo(ele);
                                  targetEditOpenHandle();
                                  // individualExperienceCenter(ele);
                                }}
                              />
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  <TableRow></TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------AGM Table For admin-------------------------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head"))) &&
        JSON.stringify(adminTableData) !== "{}" &&
        adminTableData?.data?.agm.length > 0 &&
        (radioValue === "all" || radioValue === "AGM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>AGM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayAdminAgm?.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                          {/* March-
                      {`${yearFilterValue + 1 || new Date().getFullYear() + 1}`} */}
                        </TableCell>
                      );
                    })}
                    {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminTableData) !== "{}" &&
                    adminTableData?.data?.agm.map((ele, index) => (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {ele?.user?.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={ele?.user?.experienceCenter?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {ele?.user?.experienceCenter
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {ele?.user?.experienceCenter?.length > 3 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {ele?.targets?.map((item) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {/* {formatRupees(item.value)} */}
                              {formatRupees(item.value)}
                            </TableCell>
                          );
                        })}

                        {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                          <TableCell className={classes.tableCell}>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "37px",
                                  color: "gray",
                                  padding: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setEditInfoRow(ele);
                                  // setExperienceCenterInfo(ele);
                                  targetEditOpenHandle();
                                  // individualExperienceCenter(ele);
                                }}
                              />
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  <TableRow></TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------salesManager Table For admin-------------------------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head"))) &&
        JSON.stringify(adminTableData) !== "{}" &&
        adminTableData?.data?.salesManager.length > 0 &&
        (radioValue === "all" || radioValue === "SM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>SM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayAdminSm?.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                          {/* March-
                      {`${yearFilterValue + 1 || new Date().getFullYear() + 1}`} */}
                        </TableCell>
                      );
                    })}
                    {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminTableData) !== "{}" &&
                    adminTableData?.data?.salesManager.map((ele, index) => (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {ele?.user?.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={ele?.user?.experienceCenter?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {ele?.user?.experienceCenter
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {ele?.user?.experienceCenter?.length > 3 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {ele?.targets.map((item) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {/* {formatRupees(item.value)} */}
                              {formatRupees(item.value)}
                            </TableCell>
                          );
                        })}

                        {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                          <TableCell className={classes.tableCell}>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "37px",
                                  color: "gray",
                                  padding: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setEditInfoRow(ele);
                                  // setExperienceCenterInfo(ele);
                                  targetEditOpenHandle();
                                  // individualExperienceCenter(ele);
                                }}
                              />
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  <TableRow></TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------assistantManager Table For admin-------------------------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head"))) &&
        JSON.stringify(adminTableData) !== "{}" &&
        adminTableData?.data?.assistantManager.length > 0 &&
        (radioValue === "all" || radioValue === "ASM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>ASM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayAdminAsm?.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                        </TableCell>
                      );
                    })}
                    {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminTableData) !== "{}" &&
                    adminTableData?.data?.assistantManager.map((ele, index) => (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {ele?.user?.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={ele?.user?.experienceCenter?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {ele?.user?.experienceCenter
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {ele?.user?.experienceCenter?.length > 3 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {ele?.targets?.map((item) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {/* {formatRupees(item.value)} */}
                              {formatRupees(item.value)}
                            </TableCell>
                          );
                        })}

                        {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                          <TableCell className={classes.tableCell}>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "37px",
                                  color: "gray",
                                  padding: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setEditInfoRow(ele);
                                  // setExperienceCenterInfo(ele);
                                  targetEditOpenHandle();
                                  // individualExperienceCenter(ele);
                                }}
                              />
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  <TableRow></TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------salesUser Table For admin-------------------------------- */}
      {(userDetails?.roles?.some((role) => (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head"))) &&
        JSON.stringify(adminTableData) !== "{}" &&
        adminTableData?.data?.salesUser.length > 0 &&
        (radioValue === "all" || radioValue === "SE") && (
          <div>
            <h3 style={{marginTop:"12px"}}>SE Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayAdminSe.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                        </TableCell>
                      );
                    })}
                    {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(adminTableData) !== "{}" &&
                    adminTableData?.data?.salesUser.map((ele, index) => (
                      <TableRow key={index}>
                        <TableCell className={classes.tableCell}>
                          {index + 1}
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {ele?.user?.name}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={ele?.user?.experienceCenter?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {ele?.user?.experienceCenter
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {ele?.user?.experienceCenter?.length > 3 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                        {ele?.targets?.map((item) => {
                          return (
                            <TableCell className={classes.tableCell}>
                              {/* {formatRupees(item.value)} */}
                              {formatRupees(item.value)}
                            </TableCell>
                          );
                        })}

                        {(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) && (
                          <TableCell className={classes.tableCell}>
                            <Box
                              sx={{ display: "flex", justifyContent: "center" }}
                            >
                              <EditIcon
                                style={{
                                  fontSize: "37px",
                                  color: "gray",
                                  padding: "5px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setEditInfoRow(ele);
                                  // setExperienceCenterInfo(ele);
                                  targetEditOpenHandle();
                                  // individualExperienceCenter(ele);
                                }}
                              />
                            </Box>
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  <TableRow></TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------Hierarchy table DGM-------------- */}

      {!(userDetails?.roles?.some((role) => (role?.name?.includes("Admin") && adminToggle === true) || role?.name?.includes("Center Head"))) &&
        JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.dgm.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "DGM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>DGM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayHierarchyDgm?.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                        </TableCell>
                      );
                    })}
                    {(userDetails._id !== dgmId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.dgm.length > 0 &&
                    hierarchyData?.data?.dgm.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.name}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                          <Tooltip
                            title={ele?.user?.experienceCenter?.join(", ") || ""}
                            arrow
                            placement="top"
                          >
                            <span>
                              {ele?.user?.experienceCenter
                                ?.slice(0, 2)
                                .map((ec, index, array) => {
                                  const truncatedEc = ec.length > 19 ? `${ec.slice(0, 19)}..` : ec;
                                  return (
                                    <span key={index}>
                                      {truncatedEc}
                                      {index < array.length - 1 ? ", " : ""}
                                    </span>
                                  );
                                })}
                              {ele?.user?.experienceCenter?.length > 3 ? ".." : ""}
                            </span>
                          </Tooltip>
                        </TableCell>
                          {ele?.targets?.map((targets) => {
                            return (
                              <TableCell className={classes.tableCell}>
                                {" "}
                                {formatRupees(targets.value)}{" "}
                              </TableCell>
                            );
                          })}
                          {(userDetails._id !== dgmId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales"))) && (
                            <TableCell className={classes.tableCell}>
                              <Box
                                sx={{ display: "flex", justifyContent: "center" }}
                              >
                                <EditIcon
                                  style={{
                                    fontSize: "37px",
                                    color: "gray",
                                    padding: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setEditInfoRow(ele);
                                    // setExperienceCenterInfo(ele);
                                    targetEditOpenHandle();
                                    // individualExperienceCenter(ele);
                                  }}
                                />
                              </Box>
                            </TableCell>
                          )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------Hierarchy table AGM-------------- */}

      {!(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
        JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.agm.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "AGM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>AGM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayHierarchyAgm?.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                        </TableCell>
                      );
                    })}
                    {(userDetails._id !== agmId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales") || role?.name?.includes("AGM Sales"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.agm.length > 0 &&
                    hierarchyData?.data?.agm.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.name}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.experienceCenter?.map(
                              (ec, index, array) => {
                                return (
                                  <span key={index}>
                                    {ec}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              }
                            )}
                          </TableCell>
                          {ele?.targets?.map((targets) => {
                            return (
                              <TableCell className={classes.tableCell}>
                                {" "}
                                {formatRupees(targets.value)}{" "}
                              </TableCell>
                            );
                          })}
                          {(userDetails._id !== agmId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales") || role?.name?.includes("AGM Sales"))) && (
                            <TableCell className={classes.tableCell}>
                              <Box
                                sx={{ display: "flex", justifyContent: "center" }}
                              >
                                <EditIcon
                                  style={{
                                    fontSize: "37px",
                                    color: "gray",
                                    padding: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setEditInfoRow(ele);
                                    // setExperienceCenterInfo(ele);
                                    targetEditOpenHandle();
                                    // individualExperienceCenter(ele);
                                  }}
                                />
                              </Box>
                            </TableCell>
                          )}

                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------Hierarchy table SM-------------- */}

      {!(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
        JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.manager.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "SM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>SM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayHierarchySm?.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                        </TableCell>
                      );
                    })}
                    {(userDetails._id !== smId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales") || role?.name?.includes("AGM Sales") || role?.name?.includes("Sales Manager"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.manager.length > 0 &&
                    hierarchyData?.data?.manager.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.name}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.experienceCenter?.map(
                              (ec, index, array) => {
                                return (
                                  <span key={index}>
                                    {ec}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              }
                            )}
                          </TableCell>
                          {ele?.targets?.map((targets) => {
                            return (
                              <TableCell className={classes.tableCell}>
                                {" "}
                                {formatRupees(targets.value)}{" "}
                              </TableCell>
                            );
                          })}
                          {(userDetails._id !== smId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales") || role?.name?.includes("AGM Sales") || role?.name?.includes("Sales Manager"))) && (
                            <TableCell className={classes.tableCell}>
                              <Box
                                sx={{ display: "flex", justifyContent: "center" }}
                              >
                                <EditIcon
                                  style={{
                                    fontSize: "37px",
                                    color: "gray",
                                    padding: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setEditInfoRow(ele);
                                    // setExperienceCenterInfo(ele);
                                    targetEditOpenHandle();
                                    // individualExperienceCenter(ele);
                                  }}
                                />
                              </Box>
                            </TableCell>
                          )}

                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------Hierarchy table ASM-------------- */}

      {!(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
        JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.assistantManager.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "ASM") && (
          <div>
            <h3 style={{marginTop:"12px"}}>ASM Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayHierarchyAsm?.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                        </TableCell>
                      );
                    })}
                    {(userDetails._id !== asmId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales") || role?.name?.includes("AGM Sales") || role?.name?.includes("Sales Manager"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.assistantManager.length > 0 &&
                    hierarchyData?.data?.assistantManager.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.name}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.experienceCenter?.map(
                              (ec, index, array) => {
                                return (
                                  <span key={index}>
                                    {ec}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              }
                            )}
                          </TableCell>
                          {ele?.targets?.map((targets) => {
                            return (
                              <TableCell className={classes.tableCell}>
                                {" "}
                                {formatRupees(targets.value)}{" "}
                              </TableCell>
                            );
                          })}
                          {(userDetails._id !== asmId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales") || role?.name?.includes("AGM Sales") || role?.name?.includes("Sales Manager") || role?.name?.includes("Assistant Sales Manager"))) && (
                            <TableCell className={classes.tableCell}>
                              <Box
                                sx={{ display: "flex", justifyContent: "center" }}
                              >
                                <EditIcon
                                  style={{
                                    fontSize: "37px",
                                    color: "gray",
                                    padding: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setEditInfoRow(ele);
                                    // setExperienceCenterInfo(ele);
                                    targetEditOpenHandle();
                                    // individualExperienceCenter(ele);
                                  }}
                                />
                              </Box>
                            </TableCell>
                          )}

                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}

      {/* -----------------------Hierarchy table SE-------------- */}

      {!(userDetails?.roles?.some((role) => role?.name?.includes("Admin") || role?.name?.includes("Center Head"))) &&
        JSON.stringify(hierarchyData) !== "{}" &&
        hierarchyData?.data?.executive.length > 0 &&
        (radioValue === "all" || radioValue === "NA" || radioValue === "SE") && (
          <div>
            <h3 style={{marginTop:"12px"}}>SE Table</h3>
            <TableContainer component={Paper} style={{ marginTop: "1rem" }}>
              <Table
                className={classes.table}
                aria-label="knowledge details table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Sl.No
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className={classes.tableCell}
                      style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                    >
                      Exp Center
                    </TableCell>
                    {longestTargetsArrayHierarchySe?.map((header) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          style={{
                            fontWeight: 800,
                            backgroundColor: "#cccccc",
                          }}
                        >
                          {findMonthName(header?.month)}-{header?.year}
                        </TableCell>
                      );
                    })}

                    {(userDetails._id !== executiveId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales") || role?.name?.includes("AGM Sales") || role?.name?.includes("Sales Manager") || role?.name?.includes("Assistant Sales Manager") || role?.name?.includes("Sales User"))) && (
                      <TableCell
                        className={classes.tableCell}
                        style={{ fontWeight: 800, backgroundColor: "#cccccc" }}
                      >
                        Action
                      </TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {JSON.stringify(hierarchyData) !== "{}" &&
                    hierarchyData?.data?.executive.length > 0 &&
                    hierarchyData?.data?.executive.map((ele, index) => {
                      return (
                        <TableRow>
                          <TableCell className={classes.tableCell}>
                            {index + 1}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.name}
                          </TableCell>
                          <TableCell className={classes.tableCell}>
                            {ele?.user?.experienceCenter?.map(
                              (ec, index, array) => {
                                return (
                                  <span key={index}>
                                    {ec}
                                    {index < array.length - 1 ? ", " : ""}
                                  </span>
                                );
                              }
                            )}
                          </TableCell>
                          {ele?.targets?.map((targets) => {
                            return (
                              <TableCell className={classes.tableCell}>
                                {" "}
                                {formatRupees(targets.value)}{" "}
                              </TableCell>
                            );
                          })}
                          {(userDetails._id !== executiveId && userDetails?.roles?.some((role) => role?.name?.includes("DGM Sales") || role?.name?.includes("AGM Sales") || role?.name?.includes("Sales Manager") || role?.name?.includes("Assistant Sales Manager") || role?.name?.includes("Sales User"))) && (
                            <TableCell className={classes.tableCell}>
                              <Box
                                sx={{ display: "flex", justifyContent: "center" }}
                              >
                                <EditIcon
                                  style={{
                                    fontSize: "37px",
                                    color: "gray",
                                    padding: "5px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setEditInfoRow(ele);
                                    // setExperienceCenterInfo(ele);
                                    targetEditOpenHandle();
                                    // individualExperienceCenter(ele);
                                  }}
                                />
                              </Box>
                            </TableCell>
                          )}

                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
    </div>
  );
}

export default connect(null, { setLoading, setSnackInfo })(SalesTarget);
